var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAccIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4929 2.20165C9.16739 2.20165 7.28222 4.08679 7.28222 6.41226C7.28222 8.73774 9.16741 10.6229 11.4929 10.6229C13.8184 10.6229 15.7035 8.73775 15.7035 6.41226C15.7035 4.08679 13.8184 2.20165 11.4929 2.20165ZM5.08057 6.41226C5.08057 2.87082 7.95149 0 11.4929 0C15.0343 0 17.9052 2.87083 17.9052 6.41226C17.9052 9.95368 15.0343 12.8246 11.4929 12.8246C7.95147 12.8246 5.08057 9.95368 5.08057 6.41226Z",
    fill: "#1CCAE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0293 19.8203C1.0293 14.743 5.14389 10.6284 10.2212 10.6284H12.7531C17.8304 10.6284 21.945 14.743 21.945 19.8203C21.945 20.4283 21.4521 20.9211 20.8442 20.9211C20.2362 20.9211 19.7433 20.4283 19.7433 19.8203C19.7433 15.9589 16.6145 12.8301 12.7531 12.8301H10.2212C6.35981 12.8301 3.23095 15.9589 3.23095 19.8203C3.23095 20.4283 2.73809 20.9211 2.13012 20.9211C1.52215 20.9211 1.0293 20.4283 1.0293 19.8203Z",
    fill: "#01A7C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30242 7.49112C6.30242 5.16563 8.18759 3.28045 10.5131 3.28045C12.8385 3.28045 14.7237 5.16564 14.7237 7.49112C14.7237 9.81659 12.8386 11.7017 10.5131 11.7017C8.18757 11.7017 6.30242 9.8166 6.30242 7.49112ZM10.5131 1.0788C6.97163 1.0788 4.10077 3.94971 4.10077 7.49112C4.10077 9.3671 4.90635 11.0549 6.19046 12.2275C2.61617 13.487 0.0551758 16.8935 0.0551758 20.8992C0.0551758 21.5071 0.548033 22 1.156 22C1.76397 22 2.25683 21.5071 2.25683 20.8992C2.25683 17.0378 5.3857 13.9089 9.24708 13.9089H11.779C15.6404 13.9089 18.7692 17.0378 18.7692 20.8992C18.7692 21.5071 19.2621 22 19.8701 22C20.478 22 20.9709 21.5071 20.9709 20.8992C20.9709 16.8935 18.4099 13.487 14.8357 12.2275C16.1198 11.0549 16.9254 9.36711 16.9254 7.49112C16.9254 3.9497 14.0545 1.0788 10.5131 1.0788Z",
    fill: "#01A7C3",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccIco);
export default __webpack_public_path__ + "static/media/menu_acc_ico.3aac7a559efea8fad16b42e570bafe94.svg";
export { ForwardRef as ReactComponent };